import React from 'react'

import {noop} from 'es-toolkit'

import './_toggle-field.scss'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'label'>,
  {
    checked?: boolean
    disabled?: boolean
    id?: string
    name?: string
    label?: React.ReactNode
    value?: string
    invert?: boolean
    emphasized?: boolean // Variant with more prominent coloring
    status?: 'default' | 'warning'
    onChange?: (
      checked: boolean,
      name: string | undefined,
      event: React.ChangeEvent<HTMLInputElement>
    ) => void
  }
>

const ToggleField = ({
  checked,
  className,
  disabled = false,
  invert = false,
  emphasized = false,
  status = 'default',
  id,
  name,
  onChange = noop,
  value,
  label,
  ...props
}: Props) => {
  const actualId = useUniqueId(id)

  return (
    <label
      {...props}
      htmlFor={actualId}
      className={cn(
        'ToggleField',
        {
          checked: !!checked,
          emphasized,
          invert,
          label: !!label,
          [`status-${status}`]: true,
        },
        className
      )}
      aria-disabled={disabled}
    >
      <span className="ToggleField__toggle" />
      <input
        className="ToggleField__input"
        type="checkbox"
        id={actualId}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={event => onChange(!checked, name, event)}
      />
      {label}
    </label>
  )
}

export default ToggleField
